<template>
  <div class="logo-control-button block text-xs">
      <button class="px-1 py-0" @click="toggleBodyClass('addClass', 'logo-upload')">Upload Logo</button>
  </div>
</template>

<script>

    export default {

        methods: {
          toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
              el.classList.add(className);
            } else {
              el.classList.remove(className);
            }
          },
        },

    }
</script>